'use strict';

import {Component, OnInit} from "@angular/core";
import {LoggerService} from "../common/logger.service";
import {UsanaObject} from "../usana-object";
import {LandingService} from "./landing.service";
import {IMarketingPage} from "../marketing-pages/marketing-page.models";

@Component({
    selector: 'landing-page',
    templateUrl: './landing-page.component.html',
    standalone: false
})
export class LandingPageComponent extends UsanaObject implements OnInit {

    marketingPage: IMarketingPage;
    marketingPageId: string;

    constructor(
        loggerService: LoggerService,
        private landingService: LandingService
    ) {
        super(loggerService);
    }

    ngOnInit() {
        this.getLandingPage();
    }

    getLandingPage() {
        this.landingService.getLandingPage().subscribe((page: IMarketingPage) => {
            if (page) {
                this.marketingPage = page;
            } else {
                this.useDefaultLandingPage();
            }
        }, (error: any) => {
            this.log.error(error);
            this.useDefaultLandingPage();
        });
    }

    useDefaultLandingPage() {
        this.marketingPageId = "landing-page";
    }
}
